/*
 * @Author: your name
 * @Date: 2022-03-31 09:58:10
 * @LastEditTime: 2022-06-13 14
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \VUE_HONDA_SUPPLIER_SYSTEM_APP\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import "animate.css";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import BaiduMap from 'vue-baidu-map'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use( BaiduMap, { ak : 'GG3wB6XEFH2flrH1eQVmGeE1soxjRGdl' } )
Vue.use( VueAwesomeSwiper )
Vue.use(VueVideoPlayer)

import { Button, Toast, Dialog, Image as VanImage,RadioGroup, Radio, } from 'vant';

Vue.use(Button)
    .use(Dialog)
    .use(VanImage)
    .use(Toast);
import './styles/reset.scss'
import './styles/pub.scss'


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
